<template>
  <ButtonComponent v-if="!canViewPublishedSite" v-bind="config.preview" />
  <DropdownComponent v-else :dropdown-wrapper="usePortal ? portal : 'div'">
    <ButtonComponent :label="viewSite || $t('viewSite')" icon="fa-pro-light:chevron-down" />
    <template #dropdown>
      <ButtonComponent v-bind="config.publish" />
      <ButtonComponent v-bind="config.preview" />
    </template>
  </DropdownComponent>
</template>

<script>
import { DropdownComponent } from 'vue-elder-dropdown'
import Portal from '@/components/Portal'

export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
      required: true,
    },

    viewSite: {
      type: String,
      default: '',
    },

    viewPublishedSite: {
      type: String,
      default: '',
    },
    viewPreviewSite: {
      type: String,
      default: '',
    },

    usePortal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      portal: Portal,
    }
  },

  computed: {
    canViewPublishedSite() {
      if (!this.item) return false
      if (this.isVirtualDraft(this.item)) return false

      return this.item.isPublished
    },

    config() {
      const { item } = this

      if (!item) return {}

      return {
        publish: {
          tag: 'a',
          target: '_blank',
          icon: ['fal', 'globe'],
          label: this.viewPublishedSite || this.$t('viewPublishedSite'),
          href: item.url,
          disabled: !item.url,
        },

        preview: {
          tag: 'a',
          target: '_blank',
          icon: ['fal', 'magnifying-glass'],
          label: this.viewPreviewSite || this.canViewPublishedSite ? this.$t('viewPreviewSite') : this.$t('preview'),
          href: item.previewUrl,
          disabled: !item.previewUrl,
        },
      }
    },
  },

  methods: {
    isVirtualDraft(item) {
      return item.id === item.draftId
    },
  },

  components: {
    DropdownComponent,
  },
}
</script>

<style lang="scss"></style>
